var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tl', _vm.isBusiness ? 'can-res' : 'cant-res'],style:(_vm.style),on:{"mousedown":_vm.mousedown,"click":_vm.click,"mouseenter":_vm.mouseenter,"mouseup":_vm.mouseup,"dragenter":_vm.setDragenterRowAndIndex,"drop":_vm.drop}})}
var staticRenderFns = []

export { render, staticRenderFns }